// Indicateur de chargement circulaire.
import React from "react";
import { NW } from "./tokens";
import "./Spinner.css";

export interface SpinnerProps {
  /** Diamètre en px. */
  size?: number;
  /** Couleur de l'arc animé. */
  color?: string;
  /** Couleur de l'anneau de fond. */
  trackColor?: string;
  /** Épaisseur du trait en px. */
  thickness?: number;
  /** Durée d'un tour, en secondes. */
  speed?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 14,
  color = NW.violet,
  trackColor = NW.violetLight,
  thickness = 2,
  speed = 0.7,
}) => (
  <span
    style={{
      display: "inline-block",
      width: size,
      height: size,
      border: `${thickness}px solid ${trackColor}`,
      borderTopColor: color,
      borderRadius: "50%",
      animation: `ui-spin ${speed}s linear infinite`,
      flexShrink: 0,
    }}
  />
);
